import { navLinks, siteName } from "@/mocks/editorial";

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200 text-foreground-700">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          {/* 品牌 */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-base"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                {siteName}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个聚焦“热点为何会爆、波及到谁、留下什么余波”的观察站。把个案放回规律，把热闹还给冷静。
            </p>
          </div>

          {/* 站内导航 */}
          <nav className="md:col-span-3" aria-label="页脚导航">
            <h3 className="font-heading text-sm font-semibold text-foreground-900">
              栏目
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="whitespace-nowrap transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 关于与联系 */}
          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-semibold text-foreground-900">
              关于与联系
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="#about" className="transition-colors hover:text-primary-700">
                  关于瓜爆观察
                </a>
              </li>
              <li>
                <a href="#faq" className="transition-colors hover:text-primary-700">
                  常见问题
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="transition-colors hover:text-primary-700"
                >
                  订阅与咨询
                </a>
              </li>
            </ul>
            <p className="mt-4 text-sm text-foreground-600">
              <i className="ri-mail-line mr-1"></i>
              guabao-observe@example.com
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>
            © {new Date().getFullYear()} {siteName} · 专注热点传播与余波观察
          </p>
          <p className="max-w-md text-right sm:text-left">
            内容仅供学习与观察参考，具体事实请以官方信源为准。
          </p>
        </div>
      </div>
    </footer>
  );
}